import { API_BASE_URL, requestJson } from "../api/apiClient";

const BASE = "/api/admin/weather/source-metrics";

export async function fetchWeatherSourceMetricsSummary({ range = "24h", sourceCode = null } = {}) {
  const params = new URLSearchParams({ range });
  if (sourceCode) {
    params.set("sourceCode", sourceCode);
  }
  return requestJson(`${BASE}/summary?${params.toString()}`);
}

export async function fetchWeatherSourceMetricsHistory({
  sourceCode,
  range = "24h",
  metric = "status",
} = {}) {
  const params = new URLSearchParams({ sourceCode, range, metric });
  return requestJson(`${BASE}/history?${params.toString()}`);
}

export async function fetchWeatherFallbackSummary({ range = "24h" } = {}) {
  const params = new URLSearchParams({ range });
  return requestJson(`${BASE}/fallbacks?${params.toString()}`);
}

export async function collectWeatherSourceMetrics() {
  return requestJson(`${BASE}/collect`, { method: "POST" });
}

export async function recordRadarSourceDecision(payload) {
  const response = await fetch(`${API_BASE_URL}/api/weather/radar/source-decision`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });

  if (response.status === 204 || response.status === 202) {
    return { ok: true };
  }

  if (!response.ok) {
    throw new Error(`Decision record failed (${response.status})`);
  }

  return response.json();
}
